import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  header: {
    padding: `0 ${theme.spacing.space16}px`,
    display: "flex",
    alignItems: "center",
    height: 70,
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: theme.zIndex.dialog,
    background: theme.colors.background1,
    boxSizing: "border-box",
  },
  logo: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  },
  continuePlay: {
    gap: theme.spacing.space16,
    padding: `${theme.spacing.space16}px ${theme.spacing.space20}px`,
  },
  game: {
    marginTop: 70,
  },
}));
